import { atom, type WritableAtom } from 'nanostores';

type AuthenticationSidebar = WritableAtom<boolean>;
type SystemManagementSidebar = WritableAtom<boolean>;
type SystemAuthenticationSidebar = WritableAtom<boolean>;
type ViewState = WritableAtom<'editor' | 'flow' | 'diagram'>;
type ShowUnsavedChangesModal = WritableAtom<boolean>;
type ProjectInfoTab = WritableAtom<boolean>;
export type NavigationState = { to: string; params?: Record<string, string>; search?: Record<string, unknown> };
export type PendingNavigation = WritableAtom<NavigationState | null>;
export class InterfaceStore {
  authenticationSidebar: AuthenticationSidebar;
  systemManagementSidebar: SystemManagementSidebar;
  systemAuthenticationSidebar: SystemAuthenticationSidebar;
  projectInfoTab: ProjectInfoTab;

  viewState: ViewState;

  showUnsavedChangesModal: ShowUnsavedChangesModal;

  fixDeploymentAttempts: WritableAtom<number>;

  activeDockTab: WritableAtom<string>;
  pendingNavigation: PendingNavigation;

  isDeploying: WritableAtom<boolean>;
  isSaving: WritableAtom<boolean>;
  interactionState: WritableAtom<'projectOnboarding' | 'chat'>;
  promptTemplate: WritableAtom<boolean>;
  dockOpen: WritableAtom<boolean>;
  preAuthenticateSystems: WritableAtom<boolean>;
  isChatCollapsed: WritableAtom<boolean>;
  isStreaming: WritableAtom<boolean>;

  constructor() {
    this.authenticationSidebar = atom<boolean>(false);
    this.systemManagementSidebar = atom<boolean>(false);
    this.viewState = atom<'editor' | 'flow' | 'diagram'>('flow');
    this.interactionState = atom<'projectOnboarding' | 'chat'>('projectOnboarding');
    this.promptTemplate = atom<boolean>(false);
    this.showUnsavedChangesModal = atom<boolean>(false);
    this.fixDeploymentAttempts = atom<number>(0);
    this.activeDockTab = atom<string>('logs');
    this.pendingNavigation = atom<NavigationState | null>(null);
    this.isDeploying = atom<boolean>(false);
    this.isSaving = atom<boolean>(false);
    this.dockOpen = atom<boolean>(false);
    this.preAuthenticateSystems = atom<boolean>(false);
    this.systemAuthenticationSidebar = atom<boolean>(false);
    this.isChatCollapsed = atom<boolean>(false);
    this.isStreaming = atom<boolean>(false);
    this.projectInfoTab = atom<boolean>(false);
  }

  toggleSidebar(value: boolean) {
    this.authenticationSidebar.set(value);
  }

  togglePreAuthenticateSystems(value: boolean) {
    this.preAuthenticateSystems.set(value);
  }

  toggleSystemManagement(value: boolean) {
    this.systemManagementSidebar.set(value);
  }

  toggleSystemAuthentication(value: boolean) {
    this.systemAuthenticationSidebar.set(value);
  }

  togglePromptTemplate(value: boolean) {
    this.promptTemplate.set(value);
  }

  toggleInteractionState(value: 'projectOnboarding' | 'chat') {
    this.interactionState.set(value);
  }

  toggleView(value: 'editor' | 'flow' | 'diagram') {
    this.viewState.set(value);
  }

  setShowUnsavedChangesModal(value: boolean) {
    this.showUnsavedChangesModal.set(value);
  }

  incrementFixDeploymentAttempts() {
    this.fixDeploymentAttempts.set(this.fixDeploymentAttempts.get() + 1);
  }

  resetFixDeploymentAttempts() {
    this.fixDeploymentAttempts.set(0);
  }

  setIsDockOpen(value: boolean) {
    this.dockOpen.set(value);
  }

  setActiveDockTab(value: string) {
    this.activeDockTab.set(value);
  }

  setIsDeploying(value: boolean) {
    this.isDeploying.set(value);
  }

  setIsSaving(value: boolean) {
    this.isSaving.set(value);
  }

  toggleInteractionCollapse() {
    this.isChatCollapsed.set(!this.isChatCollapsed.get());
  }

  toggleIsStreaming(value: boolean) {
    this.isStreaming.set(value);
  }

  toggleProjectInfoTab(value: boolean) {
    this.projectInfoTab.set(value);
  }

  reset() {
    this.toggleSidebar(false);
    this.toggleView('flow');
    this.resetFixDeploymentAttempts();
    this.setIsDeploying(false);
    this.toggleInteractionState('projectOnboarding');
    this.togglePromptTemplate(false);
    this.togglePreAuthenticateSystems(false);
    this.setIsDockOpen(false);
    this.isChatCollapsed.set(false);
    this.toggleIsStreaming(false);
    this.toggleProjectInfoTab(false);
  }

  setPendingNavigation(value: NavigationState | null) {
    this.pendingNavigation.set(value);
  }
}
